import React, { Component } from 'react';

import './style.css';

import Container from '@/components/Container';
import LoadingShape from '@/components/LoadingShape';
import Button from '@/components/Button';

export default class NotFound extends Component {
  render() {
    return (
      <div className="not-found">
        <Container size="large">
          <LoadingShape isActive={true} variant="homepage" />

          <h1>404</h1>

          <p>
            I’m sorry, the page you’re looking for no longer exists - but it
            will live on in our memories, forever.
          </p>

          <Button size="large" variant="primary" to="/">
            Go to the homepage
          </Button>
        </Container>
      </div>
    );
  }
}
